import React from "react";
import DetailDiagnose from "./tabs/DetailDiagnose/DetailDiagnose";
import type { TabsProps } from "antd";
import Catalog from "./tabs/Catalog/Catalog";
import { tabKeys } from "types/enums";
import Chart from "./tabs/Chart/Chart";
import ListPatient from "./tabs/ListPatientNurse/ListPatient";
import { HistoryExamine } from "components/common";

const items: TabsProps["items"] = [
  {
    key: tabKeys.DIAGNOSE.LIST_PATIENT,
    label: `Danh sách bệnh nhân`,
    children: <ListPatient />,
  },
  {
    key: tabKeys.DIAGNOSE.DETAIL_INFO,
    label: `Chi tiết thông tin`,
    children: <DetailDiagnose></DetailDiagnose>,
  },
  {
    key: tabKeys.DIAGNOSE.EXAM_HISTORY,
    label: `Lịch sử khám bệnh`,
    children: <HistoryExamine tabName={tabKeys.DIAGNOSE.LIST_PATIENT} />,
  },
  // {
  //   key: tabKeys.DIAGNOSE.CHART,
  //   label: `Báo cáo nâng cao`,
  //   children: <Chart></Chart>,
  // },
  {
    key: tabKeys.DIAGNOSE.CATALOG,
    label: `Cấu hình danh mục CĐHA`,
    children: <Catalog></Catalog>,
  },
];
export { items };
